// extracted by mini-css-extract-plugin
export default {"btnMain":"NoteCard_btnMain__yNQL3","btn":"NoteCard_btn__fbW0i","header":"NoteCard_header__kHX6q","btnDiv":"NoteCard_btnDiv__flQEe","msgContainer":"NoteCard_msgContainer__pkoKB"};